import { Check } from "lucide-react";
import { PageLayout, PageBody, BookNowButton } from "@/components/site/PageLayout";

const PACKAGES = [
  {
    name: "Gold Package Bike Detail",
    price: "From $ 225",
    items: [
      "Meticulous hand wash of entire bike",
      "Ultra soft microfiber towel and compressed air dry",
      "Wheels and tires cleaned",
      "Clay bar treatment on all painted surfaces to remove surface contaminants",
      "Machine polish all painted surfaces to remove minor scratches, swirl marks and restore clear coat gloss",
      "Application of our Motorcycle Sealer Wax to enhance gloss and offer 4-6 months of clear coat protection to all painted surfaces",
      "All chrome and aluminum polished with special attention to all intricate areas",
      "Instrument panel cleaned",
      "Leather cleaned and conditioner applied",
    ],
  },
  {
    name: "Platinum Package Bike Detail",
    price: "From $ 350",
    items: [
      "Everything that is included in the \u201cGold Package Bike Detail\u201d",
      "Complete 3 stage paint correction, instead of the single stage polishing that's included in the \u201cGold Package Bike Detail\u201d",
      "Application of our Premium Polymer Sealant to optimize gloss and offer 6-8 months of clear coat protection to all painted surfaces",
    ],
  },
  {
    name: "Diamond Package Bike Detail & Ceramic Coating",
    price: "From $ 600",
    items: [
      "Everything that is included in the \u201cGold Package Bike Detail\u201d",
      "Everything that is included in the \u201cPlatinum Package Bike Detail\u201d",
      "3 year Ceramic Coating installation to painted surfaces, metal surfaces and windshield",
      "Leather Coating",
    ],
  },
];

export default function MotorcyclePage() {
  return (
    <PageLayout
      eyebrow="Motorcycles"
      title="Motorcycle detailing"
      titleAccent="packages"
      intro="You may have just pulled your bike out of winter storage or for whatever reason the bike needs a good detailing. Brad's Mobile Detailing should be your first and last call!"
    >
      <PageBody>
        <div className="space-y-8">
          {PACKAGES.map((p) => (
            <article key={p.name} data-testid={`moto-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="bg-[#121216] border border-[#232329] p-7 md:p-10">
              <div className="flex flex-wrap items-baseline justify-between gap-3">
                <h2 className="font-display uppercase text-2xl tracking-wide text-white">{p.name}</h2>
                <p className="font-display text-2xl text-[#FF4311]">{p.price}</p>
              </div>
              <ul className="mt-5 space-y-2.5">
                {p.items.map((i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-slate-300">
                    <Check className="w-4 h-4 mt-0.5 text-[#EA0A0B] shrink-0" />
                    {i}
                  </li>
                ))}
              </ul>
              <div className="mt-7">
                <BookNowButton to="/schedule" label="Book Your Appointment" testid={`moto-book-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
              </div>
            </article>
          ))}
        </div>
        <div className="mt-10">
          <BookNowButton to="/schedule" label="Book With Us" testid="moto-book-general" />
        </div>
      </PageBody>
    </PageLayout>
  );
}
